import {
  SchemaInstance,
  defineSchema,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  baseTrackingSchema,
  exampleBaseTrackingSchemaInstance,
} from "./base-tracking";
import { returnTrackingSchema } from "./return-tracking";

const { storeCreditAmount, storeCreditActionUrl, storeCreditExpirationDate } =
  returnTrackingSchema.fields;

export const coverageCreditExpiringSchema = defineSchema({
  fields: {
    ...baseTrackingSchema.fields,
    storeCreditAmount: {
      ...storeCreditAmount,
      documentation: "The formatted store credit amount (e.g. $25.00).",
    },
    storeCreditActionUrl: {
      ...storeCreditActionUrl,
      documentation: "The URL where the customer can use the store credit.",
    },
    storeCreditExpirationDate: {
      ...storeCreditExpirationDate,
      documentation: "The date the store credit expires.",
    },
  },
});

export const exampleCoverageCreditExpiringSchemaInstance: SchemaInstance<
  typeof coverageCreditExpiringSchema
> = {
  ...exampleBaseTrackingSchemaInstance,
  storeCreditAmount: "$25.00",
  storeCreditActionUrl: "https://example.com",
  storeCreditExpirationDate: "2024-03-15",
};
